import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'
import { getresponse } from '../../Login/actions'

const {
  REQUEST_SIGNUP,
  RECEIVE_SIGNUP_STATUS,
  ERROR_OCURED,
  AUTH_ERRORS
} = actionTypes

function requestSignup () {
  return {
    type: REQUEST_SIGNUP
  }
}

function hasErrored (bool) {
  return {
    type: ERROR_OCURED,
    hasErrored: bool
  }
}

export function recieveSignupstatus (bool, user) {
  return {
    type: RECEIVE_SIGNUP_STATUS,
    success: bool,
    user
  }
}

export function authErrors (errors) {
  return {
    type: AUTH_ERRORS,
    errors
  }
}

export function signupUser (email, password, name, plan, domain_url) {
  return function (dispatch) {
    dispatch(requestSignup())
    const payload = {
      email,
      password,
      name,
      plan,
      domain_url,
      service_name: 'webinar'
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/signup`, {
      method: 'post',
      headers: myHeaders,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          getresponse(res, res.data.user.email, res.data.user.password,'', dispatch) 
         // dispatch(recieveSignupstatus(true, name))
        } else if (res.errors) {
          dispatch(authErrors(res.errors))
        }
      })
      .catch((error) => {
          dispatch(hasErrored(true))
          isSentry(error)
        }
      )
  }
}



// WEBPACK FOOTER //
// ./src/routes/SignUp/actions/index.js